import React from "react";

// material-ui-core
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

// helpers
import { isEmpty, syntaxHighlight } from "../../utils/helpers";

const getDataStr = setting => {
  if (isEmpty(setting.value)) return "";
  if (setting.dataType === "text-json" || setting.dataType === "validation") {
    return syntaxHighlight(JSON.stringify(JSON.parse(setting.value), null, 4));
  }
  return setting.value;
};

const ViewDialog = ({ open, onClose, setting = {} }) => {
  if (!open) return <div></div>;
  return (
    <Dialog
      id="view-dialog"
      fullWidth={true}
      maxWidth={setting.dataType === "select-multiple" ? "xs" : "md"}
      open={open}
      onClose={onClose}>
      <DialogTitle id="edit-dialog-title">{setting.name || ""}</DialogTitle>
      <Divider />
      <DialogContent style={{ padding: setting.dataType === "select-multiple" ? 0 : "1.5em" }}>
        {setting.dataType === "select-multiple" ? (
          <List disablePadding dense>
            {setting.value.split(",").map((item, idx) => (
              <ListItem key={idx} divider>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
        ) : setting.dataType === "text-json" || setting.dataType === "validation" ? (
          <span style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", fontSize: 14 }} dangerouslySetInnerHTML={{ __html: getDataStr(setting) }} />
        ) : (
          <span style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", fontSize: 14 }}>{setting.value}</span>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewDialog;
